import React, { useState } from 'react'
import PageLoader from 'components/GeneralComponents/Loaders/PageLoader'
import LogoLoader from 'components/GeneralComponents/Loaders/LogoLoader'
import ParticlesOverlay from 'components/LayoutComponents/ParticlesOverlay'
import { useIntl } from 'react-intl'

const Loading = ({ loadingType, animation }) => {
  const intl = useIntl()
  const [showAnimation] = useState(animation)

  const loadingText = intl.formatMessage({ id: `loadingType.${loadingType.toLowerCase()}` })

  return (
    <ParticlesOverlay>
      {showAnimation ? (
        <LogoLoader width={500} height={500} text={loadingText} />
      ) : (
        <PageLoader text={loadingText} />
      )}
    </ParticlesOverlay>
  )
}

export default Loading
